const messages = (str, translate) => {
  if (Array.isArray(str) && str.length > 0) str = str[0];

  if (!str || typeof str !== 'string') {
    return translate('register.errormodal.title');
  }

  if (str.includes('email')) {
    return translate('register.errormodal.email');
  }

  if (str.includes('Carrier')) {
    return translate('register.errormodal.carrier');
  }

  if (str.includes('user')) {
    return translate('register.errormodal.user');
  }

  if (str.includes('phone')) {
    return translate('register.errormodal.phone');
  }
};

export default messages;
